import * as types from "../types";

const state = {
  transactionsDrawer: false,
  transactionsOrder: [],
  transactionsCategory: "",
  transactionsStatus: [],
  transactionDetail: {},
  transactionStatusList: [],
  transactionQuery: {},
  transactionOffline: []
};
const getters = {
  [types.transactions.getters.GET_TRANSACTIONS_DRAWER]: state => {
    return state.transactionsDrawer;
  },
  [types.transactions.getters.GET_TRANSACTIONS_CATEGORY]: state => {
    return state.transactionsCategory;
  },
  [types.transactions.getters.GET_TRANSACTIONS_ORDER]: state => {
    return state.transactionsOrder;
  },
  [types.transactions.getters.GET_TRANSACTIONS_STATUS]: state => {
    return state.transactionsStatus;
  },
  [types.transactions.getters.GET_TRANSACTIONS_DETAIL]: state => {
    return state.transactionDetail;
  },
  [types.transactions.getters.GET_TRANSACTIONS_STATUS_LIST]: state => {
    return state.transactionStatusList;
  },
  [types.transactions.getters.GET_TRANSACTIONS_QUERY]: state => {
    return state.transactionQuery;
  },
  [types.transactions.getters.GET_TRANSACTIONS_OFFLINE]: state => {
    return state.transactionOffline;
  }
};
const mutations = {
  [types.transactions.mutations.MUTATE_TRANSACTIONS_DRAWER]: (
    state,
    drawerState
  ) => {
    state.transactionsDrawer = drawerState;
  },
  [types.transactions.mutations.MUTATE_TRANSACTIONS_CATEGORY]: (
    state,
    category
  ) => {
    state.transactionsCategory = category;
  },
  [types.transactions.mutations.MUTATE_TRANSACTIONS_ORDER]: (
    state,
    payload
  ) => {
    state.transactionsOrder = payload;
  },
  [types.transactions.mutations.MUTATE_TRANSACTIONS_STATUS]: (
    state,
    statusList
  ) => {
    state.transactionsStatus = statusList;
  },
  [types.transactions.mutations.MUTATE_TRANSACTIONS_DETAIL]: (
    state,
    payload
  ) => {
    state.transactionDetail = payload;
  },
  [types.transactions.mutations.MUTATE_TRANSACTIONS_STATUS_LIST]: (
    state,
    payload
  ) => {
    state.transactionStatusList = payload;
  },
  [types.transactions.mutations.MUTATE_TRANSACTIONS_QUERY]: (
    state,
    payload
  ) => {
    state.transactionQuery = payload;
  },
  [types.transactions.mutations.MUTATE_TRANSACTIONS_OFFLINE]: (
    state,
    payload
  ) => {
    state.transactionOffline = payload;
  }
};
const actions = {
  [types.transactions.actions.ACTION_TRANSACTIONS_DRAWER]: (
    { commit },
    payload
  ) => {
    commit(types.transactions.mutations.MUTATE_TRANSACTIONS_DRAWER, payload);
  },
  [types.transactions.actions.ACTION_TRANSACTIONS_CATEGORY]: (
    { commit },
    payload
  ) => {
    commit(types.transactions.mutations.MUTATE_TRANSACTIONS_CATEGORY, payload);
  },
  [types.transactions.actions.ACTION_TRANSACTIONS_ORDER]: (
    { commit },
    payload
  ) => {
    commit(types.transactions.mutations.MUTATE_TRANSACTIONS_ORDER, payload);
  },
  [types.transactions.actions.ACTION_TRANSACTIONS_STATUS]: (
    { commit },
    payload
  ) => {
    commit(types.transactions.mutations.MUTATE_TRANSACTIONS_STATUS, payload);
  },
  [types.transactions.actions.ACTION_TRANSACTIONS_DETAIL]: (
    { commit },
    payload
  ) => {
    commit(types.transactions.mutations.MUTATE_TRANSACTIONS_DETAIL, payload);
  },
  [types.transactions.actions.ACTION_TRANSACTIONS_STATUS_LIST]: (
    { commit },
    payload
  ) => {
    commit(
      types.transactions.mutations.MUTATE_TRANSACTIONS_STATUS_LIST,
      payload
    );
  },
  [types.transactions.actions.ACTION_TRANSACTIONS_QUERY]: (
    { commit },
    payload
  ) => {
    commit(types.transactions.mutations.MUTATE_TRANSACTIONS_QUERY, payload);
  },
  [types.transactions.actions.ACTION_TRANSACTIONS_OFFLINE]: (
    { commit },
    payload
  ) => {
    commit(types.transactions.mutations.MUTATE_TRANSACTIONS_OFFLINE, payload);
  }
};
export default {
  state,
  getters,
  mutations,
  actions
};
